import actions from "./actions";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  isFetching: false,
  successMessage: "",
  errorMessage: "",
  actionType: "",
  status_code: 0,
  examination: {},
  submittedAnswer: [],
  studentresult_response: {},
  studentResults: {},
  data: [],
  activeexam: [],
  answersheet: [],
  singleanswer:[],
});

export default function Examination(state = initialState, action) {
  switch (action.type) {
    case actions.GET_QUESTION_ALL_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
      });
    case actions.GET_QUESTION_ALL_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        examination: action.data,
        data: action.response,
      });
    case actions.GET_QUESTION_ALL_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "GET_QUESTION_ALL_ERROR",
        errorMessage: action.errorMessage,
      });
    case actions.SEND_ANSWER_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
      });

    case actions.SEND_ANSWER_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        submittedAnswer: action.data,
      });

    case actions.SEND_ANSWER_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "SEND_ANSWER_ERROR",
        errorMessage: action.errorMessage,
      });

    case actions.GET_RESULT_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
      });

    case actions.GET_RESULT_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        studentresult_response: action.data,
      });

    case actions.GET_RESULT_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "GET_RESULT_ERROR",
        errorMessage: action.errorMessage,
      });

    case actions.GET_EXAM_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: "GET_EXAM_REQUEST",
      });

    case actions.GET_EXAM_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "GET_EXAM_SUCCESS",
        activeexam: action.data,
      });

    case actions.GET_EXAM_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "GET_EXAM_ERROR",
        errorMessage: action.errorMessage,
      });

    case actions.GET_ANSWER_SHEET:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: "GET_ANSWER_SHEET",
      });

    case actions.GET_ANSWER_SHEET_SUCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "GET_ANSWER_SHEET_SUCESS",
        answersheet: action.data,
      });

    case actions.GET_ANSWER_SHEET_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "GET_ANSWER_SHEET_ERROR",
        errorMessage: action.errorMessage,
      });


      case actions.GET_SINGLE_ANSWER:
        return Immutable.merge(state, {
          isFetching: true,
          actionType: "GET_SINGLE_ANSWER",
        });
  
      case actions.GET_SINGLE_ANSWER_SUCESS:
        return Immutable.merge(state, {
          isFetching: false,
          actionType: "GET_SINGLE_ANSWER_SUCESS",
          singleanswer: action.data,
        });
  
      case actions.GET_SINGLE_ANSWER_ERROR:
        return Immutable.merge(state, {
          isFetching: false,
          actionType: "GET_SINGLE_ANSWER_ERROR",
          errorMessage: action.errorMessage,
        });

    case actions.RESET_ACTION_TYPE:
      return Immutable.merge(state, {
        actionType: "",
        status_code: 0,
        errorMessage: "",
        examination: {},
        isFetching: false,
        studentresult_response: {},
      });
      case actions.RESET_ACTION_TYPE1:
        return Immutable.merge(state, {
          actionType: "",
          status_code: 0,
          errorMessage: "",
          isFetching: false,
          studentresult_response: {},
          answersheet:[]
        });

    default:
      return state;
  }
}
